import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AppToastProvider from '@components/common/AppToastProvider';
import { APP_BASENAME } from '@constants/routes';
import { getRouterBasename } from '@internal-routes';
import App from './App';
import './styles/global.less';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root was not found in the document.');
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppToastProvider>
        <BrowserRouter basename={getRouterBasename(window.location.pathname, APP_BASENAME)}>
          <App />
        </BrowserRouter>
      </AppToastProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
